import { ApiUtility } from "./ApiUtility";
import { notifyFavoriteMutation } from "../utils/favoriteFeedback";

class KalyansServices {
  kalyansRoute = "/api/settings/filters?lang=";
  kalyandata = "/api/kalyans?lang=";
  kalyandetailRoute = "/api/Kalyans/";
  favourite = "/api/kalyans/";
  categories = "/api/Kalyans/Categories?lang=";

  /** Mobile stores hi/en; Kalyan APIs expect hindi/english for name fields */
  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }
  
  getFilters(productFor: string) {
    return ApiUtility.get(
      this.kalyansRoute +
        this.getLangParam() +
        "&productFor=" +
        productFor
    );
  }
  getKalyans(
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) {
    return ApiUtility.get(
      this.kalyandata +
        this.getLangParam() +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=" +
        authorId +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&kalyanLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial
    );
  }


  getKalyanDetail = (id: string) => {
    const lang = this.getLangParam();
    return ApiUtility.get(`${this.kalyandetailRoute}${id}/SEO?lang=${lang}`);
  };
  
  getcurrentKalyan(id: string, userId?: string) {
    let url = this.kalyandetailRoute + id + "?lang=" + this.getLangParam();
    if (userId) url += "&UserId=" + userId;
    return ApiUtility.get(url);
  }

  getRelatedKalyans(id: string) {
    return ApiUtility.get(
      this.kalyandetailRoute +
        id +
        "/related?lang=" +
        this.getLangParam()
    );
  }

  getNavigationDetails(id: string) {
    return ApiUtility.post(this.kalyandetailRoute + "navigation-details", {
      kalyanId: id,
    });
  }

  addKalyanFavourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.post(this.favourite + id + "/favourite", {}), "kalyan", "added");
  };

  removeKalyanFavourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.delete(this.favourite + id + "/favourite"), "kalyan", "removed");
  };

  getKalyansById(id: any, userId: any) {
    const url = `${this.kalyandetailRoute}${id}?UserId=${userId}`;
    return ApiUtility.get(url);
  }

  getCategories = (lang?: string) => {
    let url = this.categories;
    if (lang) {
      url += `?lang=${lang}`;
    }
    return ApiUtility.get(url);
  };

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      "/api/languages/" + id + "?lang=" + this.getLangParam()
    );
  }

  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Kalyans/Categories/${identifier}?lang=` + this.getLangParam()
    );
  }

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Kalyans/Authors/${identifier}?lang=` + this.getLangParam()
    );
  }
}
export default new KalyansServices();
